module.exports = __webpack_public_path__ + "img/loop.815e3887.svg";